import { useGetPrimaryBrandIdQuery } from '../../__generated__/chirp/com/hubspot/business/units/rpc/BusinessUnitsService.hooks';

export function usePrimaryBrandId(): {
  primaryBrandId: number;
  loading: boolean;
} {
  const { data, loading } = useGetPrimaryBrandIdQuery();
  return {
    primaryBrandId: data?.primaryBrandId ?? 0,
    loading,
  };
}
